import { cn } from '@/shared/lib/cn';

export function EmptyTitle({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div data-slot="empty-title" className={cn('text-sm font-medium tracking-tight', className)} {...props} />
  );
}
